import React from "react";
import moment from "moment";

export function generateDisplayName(task) {
    const slaveText = task.slaveNo && task.slaveNo !== 1 ? ` (Slave #${task.slaveNo})` : '';
    switch (task.taskType) {
        case 'PARAM_CHANGE':
            return `Zmiana parametru ${task.parameterAddress} na ${task.value}${slaveText}`;
        case 'GET_PARAMETER':
            return `Pobierz parametr ${task.parameterAddress}${slaveText}`;
        case 'RESTART':
            return `Restart automatu${slaveText}`;
        case 'RECOVER_SETTINGS':
            return `Przywrócenie ustawień domyślnych${slaveText}`;
        case 'DISABLE_SALE': {
            const val = String(task.value);
            if (val === "1" || val === "true") {
                return `Włączenie sprzedaży${slaveText}`;
            } else if (val === "0" || val === "false") {
                return `Wyłączenie sprzedaży${slaveText}`;
            }
            return `Sterowanie sprzedażą${slaveText}`;
        }
        case 'ENABLE_SALE':
            return `Włączenie sprzedaży${slaveText}`;
        case 'GET_STATUS':
            return `Pobierz status${slaveText}`;
        case 'GET_COUNTERS':
            return `Pobierz liczniki${slaveText}`;
        case 'CLEAR_COUNTERS':
            return `Wyczyść liczniki${slaveText}`;
        case 'GET_EVENTS':
            return `Pobierz zdarzenia${slaveText}`;
        case 'CLEAR_EVENTS':
            return `Wyczyść zdarzenia${slaveText}`;
        case 'LED': {
            const val = String(task.value);
            if (val === "1") return `Włączenie oświetlenia LED${slaveText}`;
            if (val === "0") return `Wyłączenie oświetlenia LED${slaveText}`;
            return `Sterowanie LED${slaveText}`;
        }
        case 'AGGREGATE': {
            const val = String(task.value);
            if (val === "1") return `Włączenie agregatu${slaveText}`;
            if (val === "0") return `Wyłączenie agregatu${slaveText}`;
            return `Sterowanie agregatem${slaveText}`;
        }
        case 'TEMPERATURE':
            return `Zmiana temperatury na ${task.value}°C${slaveText}`;
        default:
            return `${task.taskType}${slaveText}`;
    }
}
export function toAPI(task) {
    const toUtcIso = (dateStr) => {
        if (!dateStr) return null;
        return moment(dateStr).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
    };

    if (task.endAt) {
        return [{
            Type: task.taskType,
            Value: Number(task.value),
            CreateDateTime: task.createDateTime,
            SlaveNo: task.slaveNo,
            MachineTaskId: task.machineTaskId,
            StartDateTime: toUtcIso(task.startAt),
            ReccuringEvery: task.everyNth > 0 ? task.everyNth : null,
        }, {
            Type: task.taskType,
            Value: Number(!task.value),
            CreateDateTime: task.createDateTime,
            SlaveNo: task.slaveNo,
            MachineTaskId: task.machineTaskId,
            StartDateTime: toUtcIso(task.endAt),
            ReccuringEvery: task.everyNth > 0 ? task.everyNth : null,
        }];
    } else {
        return {
            Type: task.taskType,
            Value: task.value,
            CreateDateTime: task.createDateTime,
            SlaveNo: task.slaveNo,
            MachineTaskId: task.machineTaskId,
            StartDateTime: toUtcIso(task.startAt),
            EndDateTime: toUtcIso(task.endAt),
            ReccuringEvery: task.everyNth > 0 ? task.everyNth : null,
        };
    }
}

export function fromApiResponse({Type,Value,CreateDateTime,UpdateDateTime,SlaveNo,Status,MachineTaskId,Response,StartDateTime,EndDateTime,ReccuringEvery,LastStartDateTime}) {
    return {
        id: MachineTaskId,
        taskType: Type,
        value: Value,
        createDateTime: CreateDateTime,
        updateDateTime: UpdateDateTime,
        status: Status,
        response: Response,
        machineTaskId: MachineTaskId,
        slaveNo: SlaveNo,
        startAt: StartDateTime,
        endAt: EndDateTime,
        reccuringEvery: ReccuringEvery || 0,
        lastStartDateTime: LastStartDateTime,
    };
}

export function isEquivalent(a, b) {
    return a.taskType === b.taskType && 
           a.parameterAddress === b.parameterAddress &&
           a.value === b.value;
}

export function getStatusBadge(status, isCyclic = false) {
    switch (status) {
        case 1:
            return <span className='badge badge-primary'>Nowe</span>;
        case 2:
            return <span className='badge badge-info'>Wysłano do automatu</span>;
        case 3:
            return isCyclic ? <span className='badge badge-success'>Wykonano przez automat</span> : <span className='badge badge-success'>Wykonano</span>;
        case 4:
            return <span className='badge badge-danger'>Odrzucono</span>;
        default:
            return isCyclic ? <span className='badge badge-success'>Aktywny</span> : <span className='badge badge-dark'>Nie rozpoznany status</span>;
    }
}

export function formatTaskValue(task) {
    if (task.value === null || task.value === undefined || task.value === "") {
        return "-";
    }

    const valStr = String(task.value).trim();

    switch (task.taskType) {
        case 'DISABLE_SALE':
        case 'ENABLE_SALE':
            if (valStr === "1" || valStr === "true") return "Włączenie sprzedaży";
            if (valStr === "0" || valStr === "false") return "Wyłączenie sprzedaży";
            return valStr;

        case 'LED':
            if (valStr === "1") return "Włączenie LED";
            if (valStr === "0") return "Wyłączenie LED";
            return valStr;

        case 'AGGREGATE':
            if (valStr === "1") return "Włączenie agregatu";
            if (valStr === "0") return "Wyłączenie agregatu";
            return valStr;

        case 'TEMPERATURE':
            return `${valStr}°C`;

        default:
            if (valStr === "1") return "Włączone (1)";
            if (valStr === "0") return "Wyłączone (0)";
            return valStr;
    }
}

export function getTaskName(task, configMap) {
    const taskTypeOnly = task.taskType;
    const configName = configMap.get(taskTypeOnly);
    if (configName) {
        return configName + (task.slaveNo && task.slaveNo !== 1 ? ` (Slave #${task.slaveNo})` : '');
    }
    return generateDisplayName(task);
} 
